export default __webpack_public_path__ + "static/media/Helm of the Eternal Blaze.33636a23.jpg";